/**
 * @flow
 * @format
 */

import { createRoutine } from 'redux-saga-routines';

export default {
  fetchRecord: createRoutine('FETCH_DESIGN'),
  fetchAllRecords: createRoutine('FETCH_ALL_DESIGNS'),
  saveDesignRecord: createRoutine('SAVE_DESIGN'),
  updateRecordName: createRoutine('UPDATE_RECORD_NAME'),
  copyDesign: createRoutine('COPY_DESIGN'),
  deleteDesign: createRoutine('DELETE_DESIGN'),
  updateDesign: createRoutine('UPDATE_DESIGN'),
};



// WEBPACK FOOTER //
// ./src/routines/design.js